module.exports = __webpack_public_path__ + "img/battery_pv_power_off.0f93a359.png";